const GeoFenceEntryExitIcon = ({ color = '#0C6BB9' }) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="5.8783"
        cy="5.8783"
        r="4.95015"
        fill={color}
        stroke="white"
        strokeWidth="1.85631"
      />
    </svg>
  );
};

export default GeoFenceEntryExitIcon;
